import { LoanDtoActionIdEnum } from 'client';
import { MultiFormContainer } from 'components/multi-form/MultiFormContainer';
import { LoadingModal } from 'components/response/LoadingModal';
import { LoanPersonalInfoSingleForm } from 'components/single-form-view/loan/LoanPersonalInfoSingleForm';
import { LoanVehicleInfoForm } from 'components/single-form-view/loan/LoanVehicleInfoForm';
import { DATA_LAYER_RESPONSE_KEY } from 'constants/DataLayers';
import {
	RESPONSE_PATH,
	RESPONSE_VIEW_ERROR,
	RESPONSE_VIEW_LO_SENTIMOS_LOAN,
	RESPONSE_VIEW_ATENCION_CON_EJECUTIVO_ASYNC,
} from 'constants/ResponseType';
import { FormContext } from 'context/FormContext';
import { useFormData } from 'hooks/useFormData';
import { useLoanServices } from 'hooks/useLoanServices';
import { useLogin } from 'hooks/useLogin';
import { useMultiFormView } from 'hooks/useMultiFormView';
import { useQueryParams } from 'hooks/useQueryParams';
import { useStorage } from 'hooks/useStorage';
import { ActionButtonConfig } from 'models/ActionButtonConfig';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { setHashedEmailInStorage } from 'utils/setHashedEmailInStorage';

type MarketplaceQueryParams = {
	plate: string;
	vehicleYear: string;
	vehicleValue: string;
};

export const LoanFromMarketplaceContainer = () => {
	const query = useQueryParams() as MarketplaceQueryParams;

	const history = useHistory();
	const [login] = useLogin();
	const {
		step,
		setStep,
		formData,
		setformData,
		enableButton,
		setEnableButton,
		showLoadingModal,
		setShowLoadingModal,
	} = useMultiFormView();

	const { createLoan, updateLoan } = useLoanServices();
	const { getItemFromStorage, saveInStorage } = useStorage();

	const { formatFormData, setInitialVariablesForm } = useFormData();

	const controlConfig: ActionButtonConfig[] = [
		{
			buttonBackName: 'Volver',
			buttonNextName: 'Siguiente',
			buttonBackClick: () => {
				window.location.href = `${process.env.REACT_APP_WORDPRESS_URL} `;
			},
			buttonNextClick: () => {
				formData.actionId = LoanDtoActionIdEnum.Knockout;
				setformData(setInitialVariablesForm(formData));
				setShowLoadingModal(true);
				setHashedEmailInStorage(formData.email);
				createLoan(formatFormData(formData), (response: any) => {
					const { id, version } = response;
					const { status } = response.knockOut;
					if (status === 'Bueno') {
						setStep(step + 1);
						saveInStorage('LOAN_MARKEPLACE', { id: id, version: version });
						saveInStorage('LOAN_MARKEPLACE', formData);

						setShowLoadingModal(false);
					} else {
						history.push(
							`${RESPONSE_PATH}/${RESPONSE_VIEW_LO_SENTIMOS_LOAN}/${DATA_LAYER_RESPONSE_KEY.LOAN_NORMAL_RECHAZO_KO}`
						);
					}
				});
			},
		},
		{
			buttonBackName: 'Volver',
			buttonNextName: 'Solicitar',
			buttonBackClick: () => {
				setStep(step - 1);
			},
			buttonNextClick: () => {
				formData.actionId = LoanDtoActionIdEnum.AsyncScoringAndFinish;
				setShowLoadingModal(true);
				updateLoan(
					{
						...formData,
						version: getItemFromStorage('LOAN_MARKEPLACE', 'version'),
						plate: getItemFromStorage('queryParams', 'plate'),
					},
					getItemFromStorage('LOAN_MARKEPLACE', 'id'),
					(_: any) => {
						history.push(
							`${RESPONSE_PATH}/${RESPONSE_VIEW_ATENCION_CON_EJECUTIVO_ASYNC}/${DATA_LAYER_RESPONSE_KEY.LOAN_NORMAL_SOLICITUD_ENVIADA}`
						);
					}
				);
			},
		},
	];

	useEffect(
		() => {
			const plate = atob(query.plate);
			sessionStorage.setItem('queryParams', JSON.stringify({ ...query, plate }));
			setShowLoadingModal(true);
			login(
				() => setShowLoadingModal(false),
				() => {
					history.push(`${RESPONSE_PATH}/${RESPONSE_VIEW_ERROR}/error`);
				}
			);
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[]
	);

	const views: JSX.Element[] = [<LoanPersonalInfoSingleForm />, <LoanVehicleInfoForm />];

	return (
		<FormContext.Provider
			value={{
				setError: setEnableButton,
				setData: setformData,
				//storage: actions.getStorageInstance(),
			}}
		>
			<LoadingModal showLoadingModal={showLoadingModal} />
			<MultiFormContainer
				controlConfig={controlConfig}
				views={views}
				currentStep={step}
				isError={enableButton}
			/>
		</FormContext.Provider>
	);
};
